export default {
  namespaced: true,
  assigned_regions: {
    title: "Assigned Regions",
    single: "assigned region",
    all: "all assigned regions",

    current_assignment: "current assignment",
    schedule_regions: "schedule regions",
    change: "change",
    change_now: "change now",

    region: "region",
    regions: "regions",
    sector: "sector",
    sectors: "sectors",

    analyst: "analyst",
    supervisor: "supervisor",
    change_supervisor: "change supervisor",
    change_sectors: "change regions",

    scheduled: "scheduled",
    programmed: "scheduled",
    manual_change: "manual change",

    init_date: "start date",
    end_date: "end date",
    active_at: "active at",
    active_at_help: "Filter assignments active at a specific date and time.",
    since: "since",

    select_supervisor: "select a supervisor",
    select_sector: "select a region",
    select_sectors: "select regions",
    select_analyst: "select an analyst",

    supervisor_optional: "Supervisor is optional.",
    no_supervisor: "no supervisor assigned",
    no_regions: "no assigned regions",

    effective_assignment: "effective assignment",
    assignment_history: "assignment history",
    programmed_assignment: "scheduled assignment",
    current_supervisor: "current supervisor",
    current_regions: "current regions",

    save_programmed: "save scheduled assignment",
    save_change: "save change",

    messages: {
      created: "Assignment created successfully.",
      updated: "Assignment updated successfully.",
      deleted: "Assignment deleted successfully.",
      changed: "Assignment changed successfully.",
      closed: "Current override closed successfully.",
      load_error: "Error loading assignments.",
      save_error: "Error saving assignment.",
      delete_error: "Error deleting assignment.",
      change_error: "Error changing assignment.",
      required_supervisor: "Please select a supervisor.",
      required_sector: "Please select at least one region.",
    },
  },
};
